// extracted by mini-css-extract-plugin
var _1 = "MobileMenu_mobileMenu__POLuX";
var _2 = "MobileMenu_showMenu__JH0zX";
export { _1 as "mobileMenu", _2 as "showMenu" }
